// extracted by mini-css-extract-plugin
export default {"bpSmall":"576px","bpLarge":"992px","bpFullHd":"1920px","bpLargeCarousel":"1500px","colorTechnologyStart":"#286bb2","colorTechnologyEnd":"#0b9898"};